import styled, { css } from 'styled-components';

const headingVariants = {
  regular: css`
    font-family: ${({ theme }) => theme.FONT.REGULAR};
  `,
  light: css`
    font-family: ${({ theme }) => theme.FONT.LIGHT};
  `,
  bold: css`
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  `
};

const StyledHeading = styled.h1`
  margin: 0;
  padding: 0;
  font-size: ${({ theme }) => theme.FONT_SIZES.XXLARGE};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};

  ${props => headingVariants[props.variant]}
`;

export default StyledHeading;
